<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-card>
          <v-card-title class="indigo white--text headline">
            โครงสร้างอัตรากำลัง
          </v-card-title>
          <v-row>
            <v-col cols="6">
              <v-sheet class="pa-4">
                <v-text-field
                  v-model="search"
                  label="ค้นหา"
                  clear-icon="mdi-close-circle-outline"
                ></v-text-field>
              </v-sheet>
              <v-card class="overflow-y-auto" max-height="600" min-width="100%">
                <v-treeview
                  v-model="selection"
                  :active.sync="active"
                  :open="ListCompany"
                  :items="ListCompany"
                  :search="search"
                  :filter="filter"
                  activatable
                  active-class="primary--text"
                  open-on-click
                  return-object
                >
                  <template slot="label" slot-scope="{ item }">
                    <a @click="onSelect(item)">{{ item.name }}</a>
                  </template>
                </v-treeview>
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <!-- profile -->
            <v-col class="pa-4" cols="5">
              <!-- ส่วนของบุคคลากร -->
              <template v-if="!selection2.children">
                <v-card class="pt-6 mx-auto" v-if="selection2.positionID">
                  <v-card-text class="text-center">
                    <v-avatar size="88">
                      <v-img
                        src="https://img.pngio.com/computer-icons-avatar-user-login-avatar-man-wearing-blue-shirt-user-login-png-728_512.jpg"
                      ></v-img>
                    </v-avatar>
                    <br />
                    <h3 class="headline mb-2">
                      {{ selection2.displayNameTH }}
                    </h3>
                    <h3 class="headline mb-2">
                      {{ selection2.positionCode }}
                    </h3>
                    <v-divider></v-divider>
                    <v-row class="text-left" tag="v-card-text">
                      <v-col tag="strong" cols="5"> ชื่ออัตรา: </v-col>
                      <v-col cols="6">{{ selection2.positionName }}</v-col>
                      <v-col tag="strong" cols="5"> ประเภทอัตรา: </v-col>
                      <v-col cols="6">{{ selection2.positionTypeName }}</v-col>
                      <v-col tag="strong" cols="5"> แผนก: </v-col>
                      <v-col cols="6">{{ selection2.masDepartmentName }}</v-col>
                      <v-col tag="strong" cols="5"> สาขา: </v-col>
                      <v-col cols="6">{{ selection2.masBranchName }}</v-col>
                      <v-col tag="strong" cols="5"> บริษัท: </v-col>
                      <v-col cols="6">{{ selection2.masCompanyName }}</v-col>
                      <v-col
                        tag="strong"
                        cols="5"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                      >
                        สถานะสมัครงาน :
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                        >กำลังประกาศรับสมัครงาน
                      </v-col>
                      <v-col
                        tag="strong"
                        cols="5"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                        >วันที่หมดอายุ (วัน) :
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                        >{{ ExpireDateApplication }} ({{
                          ExpireDateApplicationDiff
                        }}
                        วัน)
                      </v-col>
                      <v-col
                        tag="strong"
                        cols="5"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                        >จำนวนผู้สมัคร :
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="colorApplication === 'warning'"
                        class="red--text"
                        >{{ AppyRegister }} ท่าน
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-row v-if="selection2.positionStatus === 'ว่าง'">
                        <v-col cols="12">
                          <v-autocomplete
                            v-if="chackAddEmployee"
                            v-model="EmployeeID"
                            :items="Employee"
                            :rules="nameRulesErr"
                            dense
                            filled
                            label="เลือกรายชื่อพนักงาน"
                            hint="กรุณาเลือกรายชื่อพนักงาน"
                            persistent-hint
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col
                            cols="6"
                            v-if="selection2.positionStatus !== 'ว่าง'"
                          >
                            <v-btn
                              color="red"
                              dark
                              @click="dialogTimeOut = true"
                              v-if="chackAddEmployee"
                            >
                              ยกเลิกการเชื่อมต่อ
                              <v-icon dark right> mdi-close-network </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="6"
                            v-if="selection2.positionStatus === 'ว่าง'"
                          >
                            <v-btn
                              color="primary"
                              dark
                              @click="chkEmp()"
                              v-if="chackAddEmployee"
                            >
                              ยืนยันรายชื่อพนักงาน
                              <v-icon dark right>
                                mdi-checkbox-marked-circle
                              </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="6"
                            v-if="selection2.positionStatus === 'ว่าง'"
                          >
                            <v-btn
                              :color="colorApplication"
                              dark
                              @click="
                                ;(dialogApplication = true),
                                  getDataApplicationFormByID(
                                    selection2.positionCode
                                  ),
                                  getDataApplicantRegister(
                                    selection2.positionCode
                                  )
                              "
                            >
                              สร้างใบสมัครงาน
                              <v-icon dark right> mdi-account-circle </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>

                        <!-- DIALOG dialogTime วันที่เริ่มงาน-->
                        <v-dialog
                          v-model="dialogTime"
                          persistent
                          max-width="50%"
                        >
                          <v-card>
                            <v-card-title class="text-h6 grey lighten-2">
                              นำพนักงานเข้าอัตรากำลัง {{ Employee.text }}
                            </v-card-title>
                            <v-alert type="info">
                              ระบบจะบันทึกข้อมูลประวัติการทำงาน กรุณากรอกข้อมูลให้ถูกต้อง
                            </v-alert>

                            <v-col cols="12">
                              <v-row style="height: 35px">
                                <v-subheader>วันที่เริ่มตำแหน่ง:</v-subheader>
                              </v-row>
                              <v-row style="height: 35px">
                                <v-col cols="12">
                                  <v-menu
                                    v-model="menuDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="firstStartDate"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      locale="th-th"
                                      v-model="firstStartDate"
                                      @input="menuDate = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-col>
                            <br />
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                depressed
                                @click="dialogTime = false"
                              >
                                <v-icon left> mdi-cancel</v-icon>
                                ปิด
                              </v-btn>
                              <v-btn
                                elevation="2"
                                depressed
                                color="success"
                                @click.stop="updateEmployee(selection2)"
                                v-if="chackAddEmployee && firstStartDate"
                              >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                ยืนยัน
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <!-- end dialogTime วันที่เริ่มงาน-->

                        <!-- DIALOG dialogTime ออกงาน-->
                        <v-dialog
                          v-model="dialogTimeOut"
                          persistent
                          max-width="50%"
                        >
                          <v-card>
                            <v-card-title class="text-h6 grey lighten-2">
                              ยกเลิกการเชื่อมต่ออัตรากำลัง [{{
                                selection2.displayNameTH
                              }}]
                            </v-card-title>
                            <v-alert type="info">
                              ระบบจะบันทึกข้อมูลประวัติการทำงาน กรุณากรอกข้อมูลให้ถูกต้อง
                            </v-alert>

                            <v-col cols="12">
                              <v-row style="height: 35px">
                                <v-subheader>วันที่สิ้นสุดตำแหน่ง:</v-subheader>
                              </v-row>
                              <v-row style="height: 35px">
                                <v-col cols="12">
                                  <v-menu
                                    v-model="menuDate2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="endDate"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      locale="th-th"
                                      v-model="endDate"
                                      @input="menuDate2 = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-col>
                            <br />
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                depressed
                                @click="dialogTimeOut = false"
                              >
                                <v-icon left> mdi-cancel</v-icon>
                                ปิด
                              </v-btn>
                              <v-btn
                                elevation="2"
                                depressed
                                color="success"
                                @click.stop="deleteEmployee(selection2)"
                                v-if="chackAddEmployee && endDate"
                              >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                ยืนยัน
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <!-- end dialogTime ออกงาน -->

                        <!-- Update คน -->
                        <!-- สร้างใบสมัคร-->
                        <v-dialog
                          v-model="dialogApplication"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <v-card>
                            <v-toolbar dark color="primary">
                              <v-btn
                                icon
                                dark
                                @click="
                                  ;(dialogApplication = false),
                                    getDataApplicationFormByID(
                                      selection2.positionCode
                                    )
                                "
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>สร้างใบสมัครงาน</v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-list three-line subheader>
                              <v-subheader>ตำแหน่งาน</v-subheader>
                              <v-row>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >positionCode</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.positionCode
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >positionName</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.positionName
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >positionTypeName</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.positionTypeName
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >masDepartmentName</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.masDepartmentName
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >masBranchName</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.masBranchName
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >masCompanyName</v-list-item-title
                                      >
                                      <v-list-item-subtitle>{{
                                        selection2.masCompanyName
                                      }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-list>
                            <v-divider></v-divider>
                            <v-list three-line subheader>
                              <v-subheader>รายละเอียดตำแหน่งงาน</v-subheader>
                              <v-list-item>
                                <v-list-item-content>
                                  <vue-editor
                                    v-model="selection2.positionJobDescription"
                                  ></vue-editor>
                                  <v-list-item-subtitle
                                    >*รายละเอียดงานแสดงผลในหน้าสมัครงาน</v-list-item-subtitle
                                  >
                                  <v-list-item-subtitle>
                                    <v-btn
                                      color="primary"
                                      dark
                                      @click.stop="updateJD(selection2)"
                                    >
                                      ปรับปรุงรายละเอียด
                                      <v-icon dark right>
                                        mdi-checkbox-marked-circle
                                      </v-icon>
                                    </v-btn></v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider></v-divider>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-row align="center" justify="center">
                                    <v-col cols="4">
                                      <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="
                                              formUpdateItemApplication.EXPIRY_DATE
                                            "
                                            label="วันที่ปิดรับสมัคร"
                                            locale="TH"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="
                                            formUpdateItemApplication.EXPIRY_DATE
                                          "
                                          no-title
                                          locale="TH"
                                          scrollable
                                        >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="menu = false"
                                          >
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="
                                              $refs.menu.save(
                                                formUpdateItemApplication.EXPIRY_DATE
                                              )
                                            "
                                          >
                                            OK
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                      <v-switch
                                        style="margin-top: 0px"
                                        v-model="
                                          formUpdateItemApplication.appLinkStatus
                                        "
                                        inset
                                        label="สถานะเปิดรับสมัคร"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="4" v-if="!chackUpdateDelete">
                                      <v-btn
                                        color="success"
                                        dark
                                        @click.stop="
                                          submitAddApplication(
                                            formUpdateItemApplication,
                                            selection2
                                          )
                                        "
                                        style="margin-top: -20px"
                                      >
                                        ใช้งาน
                                        <v-icon dark right>
                                          mdi-checkbox-marked-circle
                                        </v-icon>
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="4" v-if="chackUpdateDelete">
                                      <v-btn
                                        color="info"
                                        dark
                                        @click.stop="
                                          editDataApp(
                                            formUpdateItemApplication,
                                            selection2
                                          )
                                        "
                                        style="margin-top: -20px"
                                      >
                                        ปรับปรุง
                                        <v-icon dark right> mdi-tools </v-icon>
                                      </v-btn>
                                      <v-btn
                                        color="red"
                                        dark
                                        v-if="AppyRegister < 1"
                                        @click.stop="
                                          deleteDataApp(
                                            formUpdateItemApplication,
                                            selection2
                                          )
                                        "
                                        style="margin-top: -20px"
                                      >
                                        ลบ
                                        <v-icon dark right> mdi-delete </v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                            <v-list three-line subheader>
                              <v-subheader
                                >ผู้สมัครตำแหน่ง
                                {{ selection2.positionName }}</v-subheader
                              >
                              <v-card>
                                <v-card-title>
                                  <v-text-field
                                    v-model="searchDataTableApplicant"
                                    append-icon="mdi-magnify"
                                    label="ค้นหา"
                                    single-line
                                    hide-details
                                  ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                  :headers="columnsApplication"
                                  :items="dataItemApplication"
                                  :search="searchDataTableApplicant"
                                  :items-per-page="10"
                                  class="elevation-1"
                                >
                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-btn
                                      color="question"
                                      fab
                                      small
                                      @click.stop="ViewApplicant(item)"
                                    >
                                      <v-icon dark> mdi-account-box </v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-list>
                          </v-card>
                        </v-dialog>
                        <!-- สร้่งใบสมัครงาน -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <!-- หน่วยนงาน -->
              <template v-if="selection2.Level === 'Department'">
                <!-- ADD -->
                <v-dialog v-model="dialogAdd" persistent max-width="80%">
                  <v-card>
                    <v-card-title>
                      <span class="headline">เพิ่มข้อมูล</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="ชื่ออัตรากำลัง*"
                              v-model="formAdd.positionName"
                              :rules="nameRules"
                              :counter="100"
                              maxlength="100"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formAdd.positionLevelCode"
                              :items="Level"
                              @change="
                                getDataHeader_G(formAdd.positionLevelCode)
                              "
                              label="ระดับอัตรากำลัง"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formAdd.positionTypeCode"
                              :items="Type"
                              label="ประเภทอัตรากำลัง"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              v-model="formAdd.positionHeader"
                              :items="Header_G"
                              label="หัวหน้าอัตรากำลัง"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formAdd.masCompanyCode"
                              :items="Company_G"
                              label="บริษัท*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formAdd.masBranchCode"
                              :items="Branch_G"
                              label="สาขา*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formAdd.masDepartmentCode"
                              :items="Department_G"
                              label="แผนก*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="ลำดับ*"
                              v-model="formAdd.positionOrderNumber"
                              type="number"
                              readonly
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <!--  -->
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="2"
                        x-large
                        color="dark darken-1"
                        text
                        @click="dialogAdd = false"
                      >
                        <v-icon left> mdi-cancel</v-icon>
                        ปิด
                      </v-btn>
                      <v-btn
                        elevation="2"
                        x-large
                        color="success"
                        text
                        @click="addData()"
                      >
                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                        เพิ่ม
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- end add -->

                <!-- edit -->
                <v-dialog v-model="dialogEdit" persistent max-width="80%">
                  <v-card>
                    <v-card-title>
                      <span class="headline">แก้ไขข้อมูล</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="ชื่ออัตรากำลัง"
                              v-model="formUpdate.positionName"
                              :rules="nameRules"
                              :counter="100"
                              maxlength="100"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formUpdate.positionLevelCode"
                              :items="Level"
                              @change="
                                getDataHeader_G(formUpdate.positionLevelCode)
                              "
                              label="ระดับอัตรากำลัง"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formUpdate.positionTypeCode"
                              :items="Type"
                              label="ประเภทอัตรากำลัง"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              v-model="formUpdate.positionHeader"
                              :items="Header_G"
                              label="หัวหน้าอัตรากำลัง"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masCompanyCode"
                              :items="Company_G"
                              label="บริษัท*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masBranchCode"
                              :items="Branch_G"
                              label="สาขา*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masDepartmentCode"
                              :items="Department_G"
                              label="แผนก*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="ลำดับ*"
                              v-model="formUpdate.positionOrderNumber"
                              type="number"
                              readonly
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <!--  -->
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="2"
                        x-large
                        color="blue darken-1"
                        text
                        @click="dialogEdit = false"
                      >
                        <v-icon left> mdi-cancel</v-icon>
                        ปิด
                      </v-btn>
                      <v-btn
                        elevation="2"
                        x-large
                        color="success"
                        text
                        @click="editData()"
                      >
                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                        แก้ไข
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- end edit -->
                <!-- edit -->
                <v-dialog v-model="dialogDelete" persistent max-width="80%">
                  <v-card>
                    <v-card-title>
                      <span class="headline">ลบข้อมูล</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="positionName*"
                              v-model="formUpdate.positionName"
                              :rules="nameRules"
                              :counter="100"
                              maxlength="100"
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formUpdate.positionLevelCode"
                              :items="Level"
                              @change="
                                getDataHeader_G(formUpdate.positionLevelCode)
                              "
                              label="positionLevelCode"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="formUpdate.positionTypeCode"
                              :items="Type"
                              label="positionTypeCode"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              v-model="formUpdate.positionHeader"
                              :items="Header_G"
                              label="positionHeader"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masCompanyCode"
                              :items="Company_G"
                              label="บริษัท*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masBranchCode"
                              :items="Branch_G"
                              label="สาขา*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="formUpdate.masDepartmentCode"
                              :items="Department_G"
                              label="แผนก*"
                              readonly
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="ลำดับ*"
                              v-model="formUpdate.positionOrderNumber"
                              type="number"
                              readonly
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <!--  -->
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="2"
                        x-large
                        color="dark darken-1"
                        text
                        @click="dialogDelete = false"
                      >
                        <v-icon left> mdi-cancel</v-icon>
                        ปิด
                      </v-btn>
                      <v-btn
                        elevation="2"
                        x-large
                        color="red darken-1"
                        text
                        @click="deleteData()"
                      >
                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                        ลบ
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- end edit -->

                <v-btn
                  color="primary"
                  depressed
                  @click.stop="(dialogAdd = true), getDataById(selection2)"
                >
                  <v-icon left>mdi-text-box-plus</v-icon> </v-btn
                ><br />
                <!-- LIST ITEM -->
                <template v-if="selection2.children">
                  <v-list three-line>
                    <template v-for="item in selection2.children">
                      <v-card class="mx-auto" outlined :key="item.id">
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1">
                              {{ item.positionStatus }}
                            </v-list-item-title>
                            <v-list-item-subtitle
                              >{{ item.positionCode }} - ({{
                                item.positionName
                              }})</v-list-item-subtitle
                            >
                          </v-list-item-content>

                          <v-list-item-avatar tile size="80" color="grey">
                            <v-img
                              src="https://img.pngio.com/computer-icons-avatar-user-login-avatar-man-wearing-blue-shirt-user-login-png-728_512.jpg"
                            ></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                        <template>
                          <v-card-actions>
                            <v-btn
                              v-if="item.positionStatus === 'ว่าง'"
                              color="question"
                              small
                              @click.stop="
                                ;(dialogEdit = true), getDataByIdEdit(item)
                              "
                            >
                              <v-icon dark> mdi-tools </v-icon>
                            </v-btn>
                            <v-btn
                              v-if="item.positionStatus === 'ว่าง'"
                              small
                              @click.stop="
                                ;(dialogDelete = true), getDataByIdEdit(item)
                              "
                            >
                              <v-icon> mdi-delete </v-icon>
                            </v-btn>
                          </v-card-actions>
                        </template>
                      </v-card>
                    </template>
                  </v-list>
                </template>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <v-col cols="12">
        <v-card elevation="7" v-if="dataReady">
          <v-tabs>
            <v-tab @click="getDataEmpNotPostion()">ตำแหน่งงาน [ว่าง]</v-tab>
            <v-tab @click="getDataEmpActivePostion()"
              >ดำรงตำแหน่งปัจจุบัน</v-tab
            >
            <v-tab @click="getDataApplicantPostion('getLinkTrue')"
              >ตำแหน่งงาน [กำลังประกาศรับสมัคร]</v-tab
            >
            <v-tab @click="getDataApplicantPostion('getLinkFalse')"
              >ตำแหน่งงาน [ปิดรับสมัคร]</v-tab
            >
          </v-tabs>
          <v-card-text>
            <v-card-title>
              <v-text-field
                v-model="searchDataTable"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="columns"
              :items="dataItem"
              :search="searchDataTable"
              :items-per-page="10"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  color="question"
                  fab
                  small
                  @click.stop=";(dialogEdit = true), onSelect(item)"
                >
                  <v-icon dark> mdi-tools </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <div v-if="!dataReady" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </v-col>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import ApplicationFroms from './PositionApplication.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { VueEditor } from 'vue2-editor'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    'application-form': ApplicationFroms,
    downloadExcel: JsonExcel,
    XLSX,
    VueEditor,
    readXlsxFile
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    LevelSate () {
      this.getDataHeader()
    },
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].includes(search)
        : undefined
    }
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      active: [],
      PK: '',
      path: '/pos_position/', // Path Model
      date: new Date().toISOString().substr(0, 10),
      menuDate: false,
      menuDate2: false,
      dataReady: true,
      // dateTime: '', // Generate DateTime
      code: 'PO', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogApplication: false,
      dialogTime: false,
      dialogTimeOut: false,
      chackUpdateDelete: false,
      chackAddEmployee: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      search: null,
      searchDataTable: '',
      searchDataTableApplicant: '',
      caseSensitive: false,
      switch1: true,
      formUpdateItemApplicationJobDescription: {
        positionJobDescription: ''
      },
      formUpdateItemApplication: {
        EXPIRY_DATE: new Date().toISOString().substr(0, 10),
        appLinkStatus: false
      },
      colorApplication: 'success',
      formAdd: {
        positionCode: '',
        positionOrderNumber: '',
        positionHeader: '', // หัวหน้า
        positionName: '',
        positionLevelCode: 'PL_202122015122506', // (E= Employee / M = Manager / B = Broad)
        positionTypeCode: 'PT_202122015543690', // (นักศึกษาฝึกงาน / ทดลองงาน / พนักงานชั่วคราว / พนักงานประจำ)
        masBranchCode: '', // สาขา
        masDepartmentCode: '',
        masCompanyCode: ''
      },
      formUpdate: {
        positionCode: '',
        positionOrderNumber: '',
        positionHeader: '', // หัวหน้า
        positionName: '',
        positionLevelCode: '', // (E= Employee / M = Manager / B = Broad)
        positionTypeCode: '', // (นักศึกษาฝึกงาน / ทดลองงาน / พนักงานชั่วคราว / พนักงานประจำ)
        masBranchCode: '', // สาขา
        masDepartmentCode: '',
        masCompanyCode: ''
      },
      formUpdateItem: {
        positionCode: '',
        positionOrderNumber: '',
        positionHeader: '', // หัวหน้า
        positionName: '',
        positionLevelCode: '', // (E= Employee / M = Manager / B = Broad)
        positionTypeCode: '', // (นักศึกษาฝึกงาน / ทดลองงาน / พนักงานชั่วคราว / พนักงานประจำ)
        masDepartmentCode: ''
      },
      formUpdateEmployee: {
        positionCode: '',
        firstStartDate: '',
        startDate: '',
        empEndDate: '',
        empId: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 100 || 'Name must be less than 100 characters'
      ],
      // End Form Config ADD EDIT
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'นำเข้าอัตนากำลัง',
          disabled: false,
          href: '/HRM/Pos/PositionImport'
        }
      ],
      // End Menu Config
      // Data Table Config
      columns: [
        // { text: 'positionID', value: 'positionID' },
        { text: 'ลำดับ', value: 'positionOrderNumber', sortable: true },
        { text: 'รหัสอัตรา', value: 'positionCode' },
        { text: 'ชื่ออัตรา', value: 'positionName' },
        { text: 'ระดับอัตรา', value: 'positionLevelName' },
        { text: 'ประเภทอัตรา', value: 'positionTypeName' },
        { text: 'ชื่อพนักงาน', value: 'displayNameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      columnsApplication: [
        // { text: 'positionID', value: 'positionID' },
        { text: 'คำนำหน้า', value: 'appTitle_NameTH' },
        { text: 'ชื่อ', value: 'appFirst_NameTH' },
        { text: 'นามสกุล', value: 'appLast_NameTH' },
        { text: 'ดูประวัติ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItemApplication: [],

      // Config Import
      columnsImport: [
        { text: 'positionID', value: 'positionID' },
        { text: 'positionOrderNumber', value: 'positionOrderNumber' },
        { text: 'positionCode', value: 'positionCode' },
        { text: 'positionHeader', value: 'positionHeader' },
        { text: 'positionHeaderName', value: 'positionHeaderName' },
        { text: 'positionName', value: 'positionName' },
        { text: 'positionLevelCode', value: 'positionLevelCode' },
        { text: 'positionLevelName', value: 'positionLevelName' },
        { text: 'positionTypeCode', value: 'positionTypeCode' },
        { text: 'positionTypeName', value: 'positionTypeName' },
        { text: 'masBranchCode', value: 'masBranchCode' },
        { text: 'masBranchName', value: 'masBranchName' },
        { text: 'masDepartmentCode', value: 'masDepartmentCode' },
        { text: 'masDepartmentName', value: 'masDepartmentName' },
        { text: 'masCompanyCode', value: 'masCompanyCode' },
        { text: 'masCompanyName', value: 'masCompanyName' },
        { text: 'positionStatus', value: 'positionStatus' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'Master-PositionImport.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        positionID: 'positionID',
        positionOrderNumber: 'positionOrderNumber',
        positionCode: 'positionCode',
        positionHeader: 'positionHeader',
        positionHeaderName: 'positionHeaderName',
        positionName: 'positionName',
        positionLevelCode: 'positionLevelCode',
        positionLevelName: 'positionLevelName',
        positionTypeCode: 'positionTypeCode',
        positionTypeName: 'positionTypeName',
        masBranchCode: 'masBranchCode',
        masBranchName: 'masBranchName',
        masDepartmentCode: 'masDepartmentCode',
        masDepartmentName: 'masDepartmentName',
        masCompanyCode: 'masCompanyCode',
        masCompanyName: 'masCompanyName',
        positionStatus: 'positionStatus'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      nameRulesErr: [v => !!v || 'กรุณาเลือกรายชื่อพนักงาน'],
      open: [1, 2],
      // End Export Config
      Branch: [], // สาขา
      Department: [], // แผนก
      Company: [], // บริษัท
      Level: [], // (E= Employee / M = Manager / B = Broad)
      Type: [], // (นักศึกษาฝึกงาน / ทดลองงาน / พนักงานชั่วคราว / พนักงานประจำ)
      Header: [], // หัวหน้างาน
      selectionType: 'independent',
      selection: [],
      selection2: [],
      ListDepartment: [],
      ListBranch: [],
      // ListCompany: [],
      ListCompany: [
        {
          id: 1,
          name: 'ข้อมูลพนักงาน',
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' }
          ]
        }
      ],
      /// ///
      Branch_G: [], // สาขา
      Department_G: [], // แผนก
      Company_G: [], // บริษัท
      Level_G: [], // (E= Employee / M = Manager / B = Broad)
      Type_G: [], // (นักศึกษาฝึกงาน / ทดลองงาน / พนักงานชั่วคราว / พนักงานประจำ)
      Header_G: [], // หัวหน้างาน
      formSelect: [],
      Employee: [],
      EmployeeID: '',
      firstStartDate: '',
      endDate: '',
      ExpireDateApplication: '',
      ExpireDateApplicationDiff: '',
      AppyRegister: ''
    }
  },
  async mounted () {
    this.getGetToken(this.DNS_IP)
    await this.reloadData()
    await this.getData(this.DNS_IP, this.path)
    await this.getDataEmpNotPostion()
  },
  methods: {
    async getDataEmpNotPostion () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import

      console.log('Test Global')

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position/getPositionEmpty',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('getData', response.data)
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataEmpActivePostion () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import

      console.log('Test Global')

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position/getPositionActive',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('getData', response.data)
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataApplicantPostion (status) {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_link_position/' + status,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('application_link_position', response.data)
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataApplicantRegister (dt) {
      // Clear Data ทุกครั้ง
      this.dataItemApplication = []
      // Clear ข้อมูลใน Import
      console.log('getDataApplicantRegister', dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_apply/' + 'get?positionCode=' + dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          console.log('getDataApplicantRegister', response.data)
          this.dataItemApplication = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          console.log(error)
        })
    },
    onSelect (item) {
      console.log(item)
      this.formSelect = []
      this.selection2 = []
      this.selection2 = item
      this.getDataApplicationFormByID(this.selection2.positionCode)
    },
    ViewApplicant (item) {
      console.log(item)
    },
    async reloadData () {
      await this.getDataEmpNotPostion()
      await this.getDataBranch()
      await this.getDataDepartment()
      await this.getDataCompany()
      await this.getDataLevel()
      await this.getDataPosType()
      await this.getDataHeader()
      await this.getDataCompany_G()
      await this.getDataEmployee()
    },
    async getDataById (item) {
      console.log('item', item.children.length + 1)
      Object.assign(this.formAdd, item)
      this.getDataCompany_G()
      this.getDataBranch_G(item.masCompanyCode)
      this.getDataDepartment_G(item.masBranchCode)
      this.getDataHeader_G(this.formAdd.positionLevelCode)
      this.formAdd.masCompanyCode = item.masCompanyCode
      this.formAdd.positionOrderNumber = String(item.children.length + 1)

      console.log('this.formAdd', this.formAdd)
    },
    async getDataByIdEdit (item) {
      console.log('item', item)
      Object.assign(this.formUpdate, item)
      this.getDataCompany_G()
      this.getDataBranch_G(item.masCompanyCode)
      this.getDataDepartment_G(item.masBranchCode)
      this.getDataHeader_G(this.formUpdate.positionLevelCode)
      this.formUpdate.masCompanyCode = item.masCompanyCode
      this.PK = item.positionID
    },
    async getRandomInt (max) {
      return Math.floor(Math.random() * Math.floor(max))
    },
    async getData () {
      this.dataItem = []
      this.ListCompany = []
      this.ListBranch = []
      this.ListDepartment = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          var rs = response.data
          console.log(this.path, rs)
          this.Department.forEach(objDepartment => {
            var d = []
            var i = 0
            var f = 0
            rs.forEach(objDepartmentItem => {
              objDepartmentItem.id = objDepartmentItem.positionCode
              objDepartmentItem.name =
                '[' +
                objDepartmentItem.positionCode +
                ']' +
                objDepartmentItem.positionName +
                '(' +
                objDepartmentItem.positionStatus +
                ')'
              if (
                objDepartment.id ===
                parseInt(
                  objDepartmentItem.masDepartmentCode.replace('DEP_', '')
                )
              ) {
                // console.log(objDepartment.name + ' [' + objDepartmentItem.masDepartmentCode + ']')
                // console.log(d.length)
                if (objDepartmentItem.positionStatus === 'ว่าง') {
                  f = parseInt(f + 1)
                }
                i = parseInt(i + 1)
                objDepartment.blank = parseInt(i - f)
                objDepartment.active = f
                objDepartment.masBranchName = objDepartmentItem.masBranchName
                objDepartment.masBranchCode = objDepartmentItem.masBranchCode
                objDepartment.masCompanyName = objDepartmentItem.masCompanyName
                objDepartment.masCompanyCode = objDepartmentItem.masCompanyCode
                objDepartment.masDepartmentName =
                  objDepartmentItem.masDepartmentName
                objDepartment.masDepartmentCode =
                  objDepartmentItem.masDepartmentCode
                objDepartment.Level = 'Department'
                d.push(objDepartmentItem)
                objDepartment.children = d
              }
            })
            if (objDepartment.children) {
              objDepartment.name =
                objDepartment.name +
                ' ( ' +
                parseInt(i - f) +
                'คน / ' +
                f +
                ' ว่าง)'

              this.ListDepartment.push(objDepartment)
            }
          })

          // console.log('Department', this.ListDepartment)

          this.Branch.forEach(objBranch => {
            var b = []
            this.ListDepartment.forEach(objBranchItem => {
              if (
                objBranch.id ===
                parseInt(objBranchItem.masBranchCode.replace('BCH_', ''))
              ) {
                // objCompany.id = objBranchItem.masCompanyCode
                // objCompany.name = objBranchItem.masCompanyName
                objBranch.masBranchName = objBranchItem.masBranchName
                objBranch.masBranchCode = objBranchItem.masBranchCode
                objBranch.masCompanyName = objBranchItem.masCompanyName
                objBranch.masCompanyCode = objBranchItem.masCompanyCode
                objBranch.masDepartmentName = objBranchItem.masDepartmentName
                objBranch.masDepartmentCode = objBranchItem.masDepartmentCode
                objBranch.Level = 'Branch'
                b.push(objBranchItem)
                objBranch.children = b
              }
            })
            if (objBranch.children) {
              this.ListBranch.push(objBranch)
            }
          })

          // console.log('ListBranch', this.ListBranch)

          this.Company.forEach(objCompany => {
            var c = []
            this.ListBranch.forEach(objCompanyItem => {
              if (
                objCompany.id ===
                parseInt(objCompanyItem.masCompanyCode.replace('COMPANY_', ''))
              ) {
                // objCompany.id = objBranchItem.masCompanyCode
                // objCompany.name = objBranchItem.masCompanyName
                objCompany.masBranchName = objCompanyItem.masBranchName
                objCompany.masBranchCode = objCompanyItem.masBranchCode
                objCompany.masCompanyName = objCompanyItem.masCompanyName
                objCompany.masCompanyCode = objCompanyItem.masCompanyCode
                objCompany.masDepartmentName = objCompanyItem.masDepartmentName
                objCompany.masDepartmentCode = objCompanyItem.masDepartmentCode
                objCompany.Level = 'Company'
                c.push(objCompanyItem)
                objCompany.children = c
              }
            })
            if (objCompany.children) {
              this.ListCompany.push(objCompany)
            }
          })

          // console.log('ListCompany', this.ListCompany)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          // console.log(error)
        })
    },
    // Employee
    async getDataEmployee () {
      // Clear Data ทุกครั้ง
      this.Employee = []
      /// / // console.log('Branch')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee/' + 'getEmp?positionCode_is_null=T',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.empId
            s.text =
              d.empTitle_NameTH +
              ' ' +
              d.empFirst_NameTH +
              ' ' +
              d.empLast_NameTH
            d = s
            this.Employee.push(d)
          }
          // console.log('Employee : ', this.Employee)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          // // console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.Branch = []
      /// / // console.log('Branch')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.id = parseInt(d.masBranchCode.replace('BCH_', ''))
            s.name = d.masBranchName
            d = s
            this.Branch.push(d)
          }
          // // console.log('Branch : ', this.Branch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      // Clear Data ทุกครั้ง
      this.Department = []
      /// / // console.log('getDataDepartment')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_department/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.id = parseInt(d.masDepartmentCode.replace('DEP_', ''))
            s.name = d.masDepartmentName
            d = s
            this.Department.push(d)
          }
          // // console.log('getDataDepartment : ', this.Department)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    // บริษัท
    async getDataCompany () {
      // Clear Data ทุกครั้ง
      this.Company = []
      /// / // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_company/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.id = parseInt(d.masCompanyCode.replace('COMPANY_', ''))
            s.name = d.masCompanyName
            d = s
            this.Company.push(d)
          }
          // // console.log('getDataCompany : ', this.Company)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    // Level
    async getDataLevel () {
      // Clear Data ทุกครั้ง
      this.Level = []
      /// / // console.log('getDataLevel')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position_level/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.positionLevelCode
            s.text = d.positionLevelName
            d = s
            this.Level.push(d)
          }
          // // console.log('getDataLevel : ', this.Level)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    // Position Type
    async getDataPosType () {
      // Clear Data ทุกครั้ง
      this.Type = []
      /// / // console.log('getDataLevel')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position_type/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.positionTypeCode
            s.text = d.positionTypeName
            d = s
            this.Type.push(d)
          }
          // // console.log('getDataPosType : ', this.Type)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    // Header
    async getDataHeader () {
      // // console.log(this.formAdd.positionLevelCode)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/pos_position_level/' +
            'get?positionLevelCode=' +
            this.formAdd.positionLevelCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data[0]
          // // console.log('getDataLevel : ', rs)
          // // Clear Data ทุกครั้ง
          this.Header = []
          /// / // console.log('getDataHeader')
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/pos_position/' +
                'get?not_in_positionLevelOrderNumber=' +
                rs.positionLevelOrderNumber,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              let rs = response.data
              for (var i = 0; i < rs.length; i++) {
                var d = rs[i]
                var s = {}
                s.value = d.positionCode
                s.text = d.positionName + '[' + d.positionLevelName + ']'
                d = s
                this.Header.push(d)
              }
              // // console.log('getDataHeader : ', this.Header)
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              // // console.log(error)
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    //
    // สาขา
    async getDataBranch_G (dt) {
      // Clear Data ทุกครั้ง
      this.Branch_G = []
      // // console.log('Branch')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/' + 'get?masCompanyCode=' + dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchCode
            s.text = d.masBranchName
            d = s
            this.Branch_G.push(d)
          }
          // console.log('Branch : ', this.Branch_G)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // console.log(error)
        })
    },
    // แผนก
    async getDataDepartment_G (dt) {
      // Clear Data ทุกครั้ง
      this.Department_G = []
      // // console.log('getDataDepartment', dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_department/' + 'get?masBranchCode=' + dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masDepartmentCode
            s.text = d.masDepartmentName
            d = s
            this.Department_G.push(d)
          }
          // console.log('getDataDepartment : ', this.Department_G)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // console.log(error)
        })
    },
    // Header
    async getDataHeader_G (dt) {
      console.log('getDataHeader', dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position_level/' + 'get?positionLevelCode=' + dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data[0]
          console.log('getDataLevel : ', rs)
          // // Clear Data ทุกครั้ง
          this.Header_G = []
          // // console.log('getDataHeader')
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/pos_position/' +
                'get?not_in_positionLevelOrderNumber=' +
                rs.positionLevelOrderNumber,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              let rs = response.data
              console.log(rs)
              for (var i = 0; i < rs.length; i++) {
                var d = rs[i]
                var s = {}
                s.value = d.positionCode
                s.text =
                  d.displayNameTH +
                  '-' +
                  d.positionName +
                  '[' +
                  d.masDepartmentName +
                  '/ ' +
                  d.masBranchName +
                  '/ ' +
                  d.masCompanyName +
                  ']'
                d = s
                this.Header_G.push(d)
              }
              // console.log('getDataHeader : ', this.Header_G)
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              // console.log(error)
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // console.log(error)
        })
    },
    // บริษัท
    async getDataCompany_G () {
      // Clear Data ทุกครั้ง
      this.Company_G = []
      /// / // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_company/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masCompanyCode
            s.text = d.masCompanyName
            d = s
            this.Company_G.push(d)
          }
          // // console.log('getDataCompany : ', this.Company)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // // console.log(error)
        })
    },
    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //

      if (this.formAdd.positionOrderNumber === '') {
        this.$swal('ผิดพลาด', 'กรุณากรอกชื่อ อัตรากำลัง', 'error')
      } else if (this.formAdd.positionOrderNumber === '') {
        this.$swal('ผิดพลาด', 'ลำดับอัตรากำลัง', 'error')
      } else if (this.formAdd.masDepartmentCode === '') {
        this.$swal('ผิดพลาด', 'กรอกชื่อ แผนก', 'error')
      } else if (this.formAdd.masBranchCode === '') {
        this.$swal('ผิดพลาด', 'กรุณาเลือก สาขา', 'error')
      } else if (this.formAdd.masCompanyCode === '') {
        this.$swal('ผิดพลาด', 'กรุณาเลือก บริษัท', 'error')
      } else {
        this.submitAdd()
      }
      console.log(this.formAdd)
    },
    async submitAdd () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = true
          this.formAdd.CREATE_USER = this.$session.getAll().data.userName
          this.formAdd.LAST_USER = this.$session.getAll().data.userName
          delete this.formAdd['id']
          delete this.formAdd['name']
          delete this.formAdd['blank']
          delete this.formAdd['active']
          delete this.formAdd['masBranchName']
          delete this.formAdd['masCompanyName']
          delete this.formAdd['masDepartmentName']
          delete this.formAdd['masCompanyCode']
          delete this.formAdd['masBranchCode']
          delete this.formAdd['Level']
          delete this.formAdd['children']
          delete this.formAdd['positionStatus']
          console.log('form', JSON.stringify(this.formAdd))

          await this.getRunningCodeGlobal(this.DNS_IP, this.code).then(
            async response => {
              this.formAdd.positionCode = response
              console.log('positionCode', this.formAdd.positionCode)
              await axios
                .post(
                  // eslint-disable-next-line quotes
                  this.DNS_IP + this.path + 'add',
                  this.formAdd,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }
                )
                .then(async response => {
                  // Debug response
                  console.log('addDataGlobal DNS_IP + PATH + "add"', response)

                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                  // Close Dialog
                  this.dialogAdd = false
                  this.dataReady = true

                  // Load Data
                  await this.reloadData()
                  await this.getData(this.DNS_IP, this.path)
                  await this.getAfterDataDepartment(
                    this.formAdd.masDepartmentCode
                  )
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  console.log('error function addDataGlobal : ', error)
                  this.dataReady = true
                })
            }
          )
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async getAfterDataDepartment (dt) {
      this.selection2 = []
      this.formSelect = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/pos_position/' + 'get?masDepartmentCode=' + dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            this.formSelect.push(d)
          }
          console.log('formSelect : ', this.formSelect)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          // console.log(error)
        })
    },
    async editData () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItem.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      console.log('this.formUpdateItem', this.formUpdateItem)

      // Debug
      console.log('EDIT PK : ', this.PK)
      console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))
      // End Debug
      // สำหรับ แก้ไขข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนแก้ไขล่าสุด
      //

      // this.dataReady = false
      // await this.editDataGlobal(
      //   this.DNS_IP,
      //   this.path,
      //   this.PK,
      //   this.formUpdateItem
      // )

      if (this.formUpdateItem.positionOrderNumber === '') {
        this.$swal('ผิดพลาด', 'กรุณากรอกชื่อ อัตรากำลัง', 'error')
      } else if (this.formUpdateItem.positionOrderNumber === '') {
        this.$swal('ผิดพลาด', 'ลำดับอัตรากำลัง', 'error')
      } else if (this.formUpdateItem.masDepartmentCode === '') {
        this.$swal('ผิดพลาด', 'กรอกชื่อ แผนก', 'error')
      } else if (this.formUpdateItem.masBranchCode === '') {
        this.$swal('ผิดพลาด', 'กรุณาเลือก สาขา', 'error')
      } else if (this.formUpdateItem.masCompanyCode === '') {
        this.$swal('ผิดพลาด', 'กรุณาเลือก บริษัท', 'error')
      } else {
        this.dataReady = false
        this.submitEdit(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      }
    },
    async submitEdit (DNS_IP, PATH, ID, DT) {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'edit/' + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              await this.reloadData()
              await this.getData(this.DNS_IP, this.path)
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      console.log('DELETE PK : ', this.PK)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataSubmit(this.DNS_IP, this.path, this.PK)
    },
    async deleteDataSubmit (DNS_IP, PATH, ID) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'delete/' + ID,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              this.selection2 = []

              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.reloadData()
              await this.getData(this.DNS_IP, this.path)
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async getDataApplicationFormByID (dt) {
      this.colorApplication = 'success'
      this.chackAddEmployee = true
      this.ExpireDateApplication = ''
      this.ExpireDateApplicationDiff = ''
      this.AppyRegister = ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/application_link_position/' +
            'getPositionCode?positionCode=' +
            dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          response.data.appLinkStatus = response.data.appLinkStatus === 'True'
          response.data.EXPIRY_DATE = moment(
            String(response.data.EXPIRY_DATE)
          ).format('YYYY-MM-DD')
          this.formUpdateItemApplication = response.data
          this.chackUpdateDelete = true
          console.log(response.data)
          this.ExpireDateApplication = response.data.EXPIRY_DATE
          this.ExpireDateApplicationDiff = response.data.ExpireDateDiff
          this.AppyRegister = response.data.AppyRegister
          if (response.data.appLinkStatus === true) {
            this.colorApplication = 'warning'
            this.chackAddEmployee = false
          }

          console.log('getDataApplicationFormByID : ', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.colorApplication = 'success'
          this.chackAddEmployee = true
          this.chackUpdateDelete = false
          console.log('error', error)
        })
    },
    submitAddApplication (dt, selection2) {
      dt.appLinkCode = this.generateCodeGlobal()
      dt.CREATE_USER = this.$session.getAll().data.userName
      dt.LAST_USER = this.$session.getAll().data.userName
      dt.positionCode = selection2.positionCode
      dt.EXPIRY_DATE = moment(String(dt.EXPIRY_DATE)).format('YYYY-MM-DD')
      console.log('submitAddApplication', dt)
      var add = {}
      add.appLinkCode = dt.appLinkCode
      add.CREATE_USER = dt.CREATE_USER
      add.LAST_USER = dt.LAST_USER
      add.positionCode = dt.positionCode
      add.EXPIRY_DATE = dt.EXPIRY_DATE
      add.appLinkStatus = dt.appLinkStatus

      console.log('submitAddApplication', add)

      if (add.EXPIRY_DATE === '' || add.EXPIRY_DATE === null) {
        this.$swal('ผิดพลาด', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
      } else {
        console.log(dt)
        this.submitAddApplicationApprove(this.DNS_IP, add)
      }
    },
    async submitAddApplicationApprove (DNS_IP, DT) {
      this.$swal({
        title: 'ต้องการ เริ่มต้นสร้างใบสมัคร ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/application_link_position/add',
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              console.log(
                'success function submitAddApplicationApprove : ',
                response
              )
              this.dialogApplication = false
              if (DT.appLinkStatus === true) {
                this.colorApplication = 'warning'
                this.chackAddEmployee = false
              } else {
                this.colorApplication = 'success'
                this.chackAddEmployee = true
              }
            })
            .catch(error => {
              console.log(
                'error function submitAddApplicationApprove : ',
                error
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function submitAddApplicationApprove : ', error)
          this.dataReady = true
        })
    },
    async updateJD (dt) {
      console.log(dt)
      // Config User ทำรายการล่าสุด
      this.formUpdateItemApplicationJobDescription.LAST_USER = this.$session.getAll().data.userName
      this.formUpdateItemApplicationJobDescription.positionJobDescription =
        dt.positionJobDescription
      console.log(this.formUpdateItemApplicationJobDescription)

      if (
        this.formUpdateItemApplicationJobDescription.positionJobDescription ===
          '' ||
        this.formUpdateItemApplicationJobDescription.positionJobDescription ===
          null
      ) {
        this.$swal('ผิดพลาด', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
      } else {
        this.dataReady = false
        this.submitEditJD(
          this.DNS_IP,
          this.path,
          dt.positionID,
          this.formUpdateItemApplicationJobDescription
        )
      }
    },
    async submitEditJD (DNS_IP, PATH, ID, DT) {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItemApplicationJobDescription)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'edit/' + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              this.$swal('เรียบร่้อบ', 'ปรับปรุงรายละเอียดเรียบร้อย', 'success')
              // if (DT.appLinkStatus === true) {
              //   this.colorApplication = 'warning'
              // } else {
              //   this.colorApplication = 'success'
              // }
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async editDataApp (dt, selection2) {
      // Config User ทำรายการล่าสุด
      dt.LAST_USER = this.$session.getAll().data.userName
      dt.positionCode = selection2.positionCode
      var pk = dt['appLinkId']
      console.log('pk', pk)
      console.log('dt', dt)
      // this.dataReady = false
      this.editDataApplicationForm(this.DNS_IP, pk, dt)
    },
    async editDataApplicationForm (DNS_IP, ID, DT) {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/application_link_position/' + 'editApplyLink/' + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              this.dataReady = true
              if (DT.appLinkStatus === true) {
                this.colorApplication = 'warning'
                this.chackAddEmployee = false
              } else {
                this.colorApplication = 'success'
                this.chackAddEmployee = true
              }
              this.dialogApplication = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteDataApp (dt) {
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      dt.LAST_USER = this.$session.getAll().data.userName
      console.log(dt)

      this.deleteDataApplicationForm(this.DNS_IP, dt.appLinkId, dt)
    },
    async deleteDataApplicationForm (DNS_IP, ID, DT) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/application_link_position/' + 'delete/' + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              this.dataReady = true
              this.colorApplication = 'success'
              this.dialogApplication = false
              this.chackAddEmployee = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async chkEmp () {
      if (this.EmployeeID !== '') {
        this.dialogTime = true
      } else {
        this.$swal('ผิดพลาด', 'กรุณาเลือกรายชื่อพนักงาน', 'error')
      }
    },
    async clearDataAdd () {
      // eslint-disable-next-line no-redeclare
      this.EmployeeID = ''
      this.firstStartDate = ''
    },
    async updateEmployee (dt) {
      if (this.EmployeeID) {
        this.dataReady = false
        console.log(dt.positionCode)
        console.log('dt', dt)
        console.log('firstStartDate', this.firstStartDate)

        let ds = {
          positionCode: dt.positionCode,
          startDate: this.firstStartDate,
          empJobStatus: 'ดำเนินการ',
          positionName: dt.positionName,
          positionTypeName: dt.positionTypeName,
          masDepartmentName: dt.masDepartmentName,
          masCompanyName: dt.masCompanyName,
          masBranchName: dt.masBranchName,
          CREATE_USER: this.$session.getAll().data.userName
        }
        console.log('ds', ds)
        // Config User ทำรายการล่าสุด
        // this.formUpdateEmployee.LAST_USER = this.$session.getAll().data.userName
        // this.formUpdateEmployee.positionCode = dt.positionCode
        // this.formUpdateEmployee.firstStartDate = dt.firstStartDate
        // this.formUpdateEmployee.startDate = dt.startDate
        // End Config User ทำรายการล่าสุด

        // Debug
        // console.log('EDIT PK : ', this.EmployeeID)
        // console.log('formUpdateItem', JSON.stringify(this.formUpdateEmployee))
        // delete this.formUpdateEmployee['empId']
        // delete this.formUpdateEmployee['empEndDate']

        this.$swal({
          title: 'ต้องการ เชื่อมต่อ ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async result => {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + '/employee/edit/' + this.EmployeeID,
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async response => {
                this.dataReady = true
                // Debug response
                this.Employee = []
                this.selection2 = []

                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogTime = false
                this.dialogEdit = false
                this.clearDataAdd()

                // Load Data
                await this.reloadData()
                await this.getData(this.DNS_IP, this.path)
                await this.getDataEmpNotPostion()
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
              })
          })
          .catch(error => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาเลือกบุคคล', 'error')
      }
    },
    async deleteEmployee (dt) {
      console.log('this.EmployeeID', dt.empId)
      console.log('select', dt)
      if (dt.empId) {
        // Config User ทำรายการล่าสุด
        // this.formUpdateEmployee.LAST_USER = this.$session.getAll().data.userName
        // this.formUpdateEmployee.positionCode = dt.positionCode
        // this.formUpdateEmployee.empEndDate = dt.empEndDate
        // End Config User ทำรายการล่าสุด
        let ds = {
          empCode: dt.empCode,
          positionCode: dt.positionCode,
          endDate: this.endDate,
          empJobStatus: 'สิ้นสุดงาน',
          LAST_USER: this.$session.getAll().data.userName
        }
        console.log('ds', ds)

        // Debug
        // console.log('EDIT PK : ', dt.empId)
        // console.log('formUpdateItemApplicationJobDescription', JSON.stringify(this.formUpdateEmployee))

        // delete this.formUpdateEmployee['firstStartDate']

        this.$swal({
          title: 'ต้องการ ยกเลิกการเชื่อมต่อ ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async result => {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + '/employee/updatePostionDelete/' + dt.empId,
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async response => {
                this.dataReady = true
                // Debug response
                this.Employee = []
                this.selection2 = []

                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogTimeOut = false
                this.dialogEdit = false

                // Load Data
                await this.reloadData()
                await this.getData(this.DNS_IP, this.path)
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
              })
          })
          .catch(error => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาเลือกบุคคล', 'error')
      }
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #262a34 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Pos/PositionImport.vue